import compose from "recompose/compose";
import withHandlers from "recompose/withHandlers";
import withState from "recompose/withState";
import withProps from "recompose/withProps";
import computeUpdatedPricesForProduct from "./computeUpdatedPrices";

export const getPriceWithSelectedGroupedItems = (
  product,
  selectedGroupedItems,
  getPrice
) => {
  const productPrice = getPrice(product.prices);
  if (productPrice === undefined || productPrice === null) {
    return null;
  }

  const hasSelection = selectedGroupedItems.some(({ qty }) => qty > 0);

  if (hasSelection) {
    return product.groupedItems.reduce((acc, { product }) => {
      let selectedValue = 0;

      const selectedGroupedItem = selectedGroupedItems.find(
        ({ sku }) => sku === product.sku
      );
      if (selectedGroupedItem) {
        const optionValuePrice = getPrice(product.prices) ?? 0;
        selectedValue = optionValuePrice * selectedGroupedItem.qty;
      }

      return acc + selectedValue;
    }, 0);
  } else if (product.groupedItems.length > 0) {
    return Math.min(
      ...product.groupedItems.map(({ product }) => getPrice(product.prices))
    );
  } else {
    return 0;
  }
};

const getInitialSelectedGroupedItems = (product) => {
  if (!product.groupedItems) {
    return null;
  }
  return product.groupedItems
    .filter(({ qty, product }) => qty > 0 && product?.stock?.isInStock)
    .map(({ qty, product }) => ({
      qty,
      sku: product.sku,
    }));
};

const withSelectedGroupedItems = () =>
  compose(
    withState("selectedGroupedItems", "selectGroupedItems", (props) =>
      getInitialSelectedGroupedItems(props.product)
    ),
    withHandlers({
      setGroupedItems: (props) => (selectedGroupedItems) => {
        props.selectGroupedItems(selectedGroupedItems.filter(Boolean));
      },
    }),
    withProps((props) => {
      if (
        !props.product.groupedItems ||
        props.product.groupedItems.length === 0
      ) {
        return {};
      }

      const prices = computeUpdatedPricesForProduct(
        props.product,
        props.selectedGroupedItems,
        getPriceWithSelectedGroupedItems
      );

      return {
        product: {
          ...props.product,
          prices,
        },
      };
    })
  );

export default withSelectedGroupedItems;
